import http from "../utils/http";

export const fetchGermanStates = async (params: string): Promise<Response> => {
  return await http.get(`/api/states${params}`);
};
